<!--  -->
<template>
  <!-- 提交工单成功 -->
  <div class="success">
    <h1>申述</h1>
    <img src="~@/assets/submitWorkOrder/submit-sucess.png" alt="">
    <h2>您已成功提交申述单，编号:{{feed_back_id}}</h2>
    <p>我们将在2个工作日内给您反馈</p>
    <p class="mb-64">后续处理进度将通过您填写的手机/邮箱通知到您！</p>
    <div class="btn-class">
      <div class="return" @click="returnHome">返回首页</div>
      <!-- <div class="next" @click="continueSubmit">继续提交</div> -->
    </div>
    <PhotonTip v-show="isPhoton"></PhotonTip>
  </div>
</template>

<script>
import PhotonTip from '@/components/photonTip'
export default {
  components: {
    PhotonTip
  },
  data() {
    return {
      isPhoton: false,
      feed_back_id: this.$route.query.feed_back_id || ""
    }
  },
  methods: {
    returnHome() {
      this.$router.push('/')
    },
    continueSubmit() {
      // this.$router.push('/workOrder/submitWorkOrder')
      history.back()
    },
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {
    this.$emit('changeShow',false)
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    const isPhoton = localStorage.getItem('isPhoton')
    this.isPhoton= isPhoton === '1'
    // 3秒隐藏光子动画
    setTimeout(() => {
      this.isPhoton = false
      localStorage.setItem('isPhoton', '')
    },3000)
  },
}
</script>
<style lang="scss" scoped>
.success {
  width: 320px;
  margin: auto;
  text-align: center;
  h1 {
    text-align: center;
    padding: 90px 0 20px 0;
    margin: 0;
  }
  img {
    width: 328px;
    height: 184px;
  }
  h2 {
    font-size: 16px;
    color: #333333;
    letter-spacing: 0;
    line-height: 20px;
    margin-top: 20px;
  }
  p {
    font-size: 14px;
    color: #666666;
    line-height: 20px;
  }
  p.mb-64{
    margin-bottom: 64px;
  }

  .btn-class {
    display: flex;
    justify-content: center;
    .return {
      cursor: pointer;
      width: 152px;
      height: 36px;
      background: #3060FF;
      font-size: 14px;
      color: #FFFFFF;
      line-height: 36px;
    }
    .next {
      cursor: pointer;
      width: 152px;
      height: 36px;
      background: #FFFFFF;
      border: 1px solid #D9D9D9;
      font-size: 14px;
      line-height: 36px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/gtn/views/frontViews/submitAppealSuccess.vue